module.exports = __webpack_public_path__ + "static/media/listView.0b1aaac2.svg";